import { render, staticRenderFns } from "./UploadImageOnPage.vue?vue&type=template&id=1ede5f18&"
import script from "./UploadImageOnPage.vue?vue&type=script&lang=js&"
export * from "./UploadImageOnPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports